export const HEADER_HEIGHT = 56;
export const DATA_BAR_HEIGHT = 30;
export const TOOLBAR_STRIP_HEIGHT = 44;
export const FILTERS_WIDTH = 280;
export const BODY_WIDTH = 430;
export const DETAIL_MIN_WIDTH = 650;
export const DETAIL_INLINE_BREAKPOINT = FILTERS_WIDTH + BODY_WIDTH + DETAIL_MIN_WIDTH;
